import { RouteRecordRaw } from 'vue-router';
import { RecordViewPage, RECORD_VIEW_STAGE_CONFIG } from '@/pages/record-view';

export const routeName = 'VerificacaoVerRegistro';

export const route: RouteRecordRaw = {
  // The `ver-registro` segment does two things. It separates the nature, because a matrix id and a
  // document revision id can collide, and it keeps the screen at three segments: with a fourth one
  // the breadcrumb would print the stage name twice, which is exactly what the criterion forbids.
  path: 'verificacao/ver-registro/:id',
  name: routeName,
  component: RecordViewPage,
  meta: {
    requiresAuth: true,
    breadcrumb: RECORD_VIEW_STAGE_CONFIG.verification.stageLabel,
    dynamicBreadcrumb: true,
    recordViewStage: 'verification',
    // The screen inherits the permission of the detail route of its own stage, and Verification
    // has a single permission: there is no separate right to read and to decide.
    permissions: [{ action: 'manageVerification', subject: 'Homologation' }],
  },
};
